import Lottie from 'lottie-react';

import lottieChatbot from '../jsons/chatbot.json';

const LottieChatbot = props => {
  return <Lottie animationData={lottieChatbot} loop={false} {...props} />;
};

export default LottieChatbot;
